/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row4_LabelInputs */

const en_mk_cmp_row4_label = /** @type {(inputs: Mk_Cmp_Row4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team & agent chat`)
};

const id_mk_cmp_row4_label = /** @type {(inputs: Mk_Cmp_Row4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat tim & agen`)
};

/**
* | output |
* | --- |
* | "Team & agent chat" |
*
* @param {Mk_Cmp_Row4_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row4_label = /** @type {((inputs?: Mk_Cmp_Row4_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row4_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row4_label(inputs)
	return en_mk_cmp_row4_label(inputs)
});